export default "__VITE_ASSET__sjJWX1ho__"